import { Component } from '@theme/component';

class TrekcampAdventureStory extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initialize();
  }
  updatedCallback() {
    super.updatedCallback();
    this.cleanup();
    this.initialize();
  }
  initialize() {
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.strip = this.refs.strip;
    if (!this.strip) return;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.fine = matchMedia('(hover: hover) and (pointer: fine)');
    this.observer = new IntersectionObserver(entries => {
      this.inView = entries[0].isIntersecting;
      if (this.inView && !this.reduced.matches) this.setAttribute('data-animated', '');
    }, { threshold: .15 });
    this.observer.observe(this);
    this.strip.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      this.drag = { id: event.pointerId, x: event.clientX, scroll: this.strip.scrollLeft, moved: false };
    }, options);
    window.addEventListener('pointermove', event => {
      if (!this.drag || event.pointerId !== this.drag.id) return;
      const distance = event.clientX - this.drag.x;
      if (Math.abs(distance) > 6) {
        this.drag.moved = true;
        this.strip.setAttribute('data-dragging', '');
        this.strip.scrollLeft = this.drag.scroll - distance;
      }
    }, options);
    const endDrag = () => {
      this.suppressClick = !!this.drag?.moved;
      this.drag = null;
      this.strip.removeAttribute('data-dragging');
      clearTimeout(this.clickTimer);
      this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 0);
    };
    window.addEventListener('pointerup', endDrag, options);
    window.addEventListener('pointercancel', endDrag, options);
    this.strip.addEventListener('click', event => {
      if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); }
    }, { ...options, capture: true });
    this.strip.addEventListener('keydown', event => {
      if (event.target !== this.strip || !['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
      event.preventDefault();
      this.strip.scrollBy({ left: this.strip.clientWidth * .7 * (event.key === 'ArrowRight' ? 1 : -1), behavior: this.reduced.matches ? 'instant' : 'smooth' });
    }, options);
    this.strip.addEventListener('scroll', () => {
      const max = this.strip.scrollWidth - this.strip.clientWidth;
      const fraction = max > 0 ? Math.min(1, Math.max(0, Math.abs(this.strip.scrollLeft) / max)) : 0;
      this.style.setProperty('--tc-progress', `${fraction * 200}%`);
      if (!this.reduced.matches && this.lastScroll !== undefined) {
        const speed = Math.abs(this.strip.scrollLeft - this.lastScroll);
        this.style.setProperty('--tc-blur', `${Math.min(.65, speed / 100)}px`);
        clearTimeout(this.blurTimer);
        this.blurTimer = setTimeout(() => this.style.setProperty('--tc-blur', '0px'), 100);
      }
      this.lastScroll = this.strip.scrollLeft;
    }, { ...options, passive: true });
    this.addEventListener('pointermove', event => {
      if (!this.fine.matches || this.reduced.matches) return;
      const picture = event.target.closest('.tc-story__picture');
      if (!picture) return;
      const rect = picture.getBoundingClientRect();
      picture.style.setProperty('--tc-x', `${event.clientX - rect.left}px`);
      picture.style.setProperty('--tc-y', `${event.clientY - rect.top}px`);
    }, options);
    window.addEventListener('scroll', () => {
      if (!this.inView || this.reduced.matches || !this.fine.matches || this.frame) return;
      this.frame = requestAnimationFrame(() => {
        const rect = this.getBoundingClientRect();
        this.style.setProperty('--tc-parallax', `${Math.max(-8, Math.min(8, (innerHeight / 2 - rect.top - rect.height / 2) * .025))}px`);
        this.frame = null;
      });
    }, { ...options, passive: true });
    this.reduced.addEventListener('change', () => {
      this.removeAttribute('data-animated');
      this.style.setProperty('--tc-parallax', '0px');
      this.style.setProperty('--tc-blur', '0px');
    }, options);
  }
  cleanup() {
    this.controller?.abort();
    this.observer?.disconnect();
    cancelAnimationFrame(this.frame);
    clearTimeout(this.blurTimer);
    clearTimeout(this.clickTimer);
  }
  disconnectedCallback() {
    this.cleanup();
    super.disconnectedCallback();
  }
}
if (!customElements.get('trekcamp-adventure-story')) customElements.define('trekcamp-adventure-story', TrekcampAdventureStory);
